import angular from 'angular';
import threeDotMenu from './threeDotMenu';
import './style.scss';

export default angular
  .module('components.threeDotMenu', [])
  .component('threeDotMenu', threeDotMenu).name;
